"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Storage = exports.KEY = void 0;
exports.KEY = 'LS_default_statuses';

var Storage =
/** @class */
function () {
  function Storage() {
    this.saveStatuses = function (statusMap) {
      var currDate = new Date(Date.now()); // Date.now() проще мокать.

      try {
        localStorage.setItem(exports.KEY, JSON.stringify({
          expires: currDate.setFullYear(currDate.getFullYear() + 1),
          value: statusMap
        })); // tslint:disable-next-line
      } catch (e) {}
    };

    this.getStatuses = function () {
      try {
        var info = localStorage.getItem(exports.KEY);

        if (!info) {
          return {};
        }

        var json = JSON.parse(info);
        var invalidData = !Object.prototype.hasOwnProperty.call(json, 'value') || !Object.prototype.hasOwnProperty.call(json, 'expires');

        if (invalidData || json.expires < Date.now()) {
          localStorage.removeItem(exports.KEY);
          return {};
        }

        return json.value; // tslint:disable-next-line
      } catch (e) {}

      return {};
    };
  }

  return Storage;
}();

exports.Storage = Storage;